import 'animate.css';

import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import * as routes from '../../../constants/Routing';
import Text from '../../../react-components/Text';
import eventsPanel, { PageViewPages } from '../../../services/events';
import { AuthBodyFooter } from '../Auth.styled';
import { RegisterDone, RegisterDoneProps } from './RegisterDone';
import { RegisterForm } from './RegisterForm';

export const Register = () => {
  const navigate = useNavigate();

  const [registeredData, setRegisteredData] = useState<RegisterDoneProps | undefined>(undefined);

  useEffect(() => {
    eventsPanel.pageView(PageViewPages.register);
  }, []);

  return (
    <>
      {registeredData ? (
        <RegisterDone name={registeredData.name} email={registeredData.email} />
      ) : (
        <RegisterForm onRegisterSuccess={(name: string, email: string) => setRegisteredData({ name, email })} />
      )}

      <Grid item>
        <VSpacer medium />
      </Grid>

      <AuthBodyFooter item container justifyContent="center">
        <Grid item>
          <Text
            isBold
            style={{
              fontSize: `12px`,
            }}
            intlId="auth.register.login"
            intlValues={{
              a: (chunks: any) => (
                <Text
                  tagName="span"
                  variant="button"
                  style={{
                    fontSize: `12px`,
                    fontWeight: `bold`,
                  }}
                  onClick={() => navigate(routes.AUTH.LOGIN)}
                >
                  {chunks}
                </Text>
              ),
            }}
          />
        </Grid>
      </AuthBodyFooter>
    </>
  );
};
